
import Vue, { CreateElement, RenderContext } from 'vue'
import { textoRico } from '@/shareds/chat-de-suporte'

/** Texto de uma bolha do chat: links clicáveis e a formatação do WhatsApp, sem HTML vindo de fora. */
export default Vue.extend({
	name: 'TextoRicoDoChat',
	functional: true,
	props: {
		texto: { type: String, default: '' },
	},
	render(h: CreateElement, contexto: RenderContext) {
		const trechos = textoRico(contexto.props.texto).map(trecho => {
			const style = {
				fontWeight: trecho.negrito ? '700' : undefined,
				fontStyle: trecho.italico ? 'italic' : undefined,
				textDecoration: trecho.riscado ? 'line-through' : undefined,
			}
			if (trecho.tipo === 'link') {
				return h('a', {
					class: 'chat-texto__link',
					style,
					attrs: { href: trecho.url, target: '_blank', rel: 'noopener noreferrer' },
				}, trecho.texto)
			}
			return h('span', { style }, trecho.texto)
		})
		return h('p', { ...contexto.data, class: ['chat-texto', contexto.data.class] }, trechos)
	},
})
